import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = { class: "flex flex-col min-w-0" }
const _hoisted_3 = { class: "text-xs font-medium uppercase tracking-wide text-gray-500 truncate" }
const _hoisted_4 = { class: "text-base font-bold text-gray-900 truncate" }


export default /*#__PURE__*/_defineComponent({
  __name: 'DoctorStatCard',
  props: {
    icon: {},
    label: {},
    value: { default: undefined },
    iconColor: { default: 'primary' },
    iconBackground: { default: 'bg-primary5' },
    testId: { default: undefined }
  },
  setup(__props: any) {

// iconColor usa tokens do Vuetify v-icon (ex: 'primary', 'green', 'grey') — NAO confundir
// com a uniao de cores do LabelBadge (que usa 'gray', sem 'e').


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    "data-testid": _ctx.testId,
    class: "flex items-center gap-3 rounded-2xl border border-gray-100 bg-white shadow-sm px-4 py-3"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex items-center justify-center w-10 h-10 rounded-lg shrink-0", _ctx.iconBackground])
    }, [
      _createVNode(_component_v_icon, {
        color: _ctx.iconColor,
        size: "20"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.icon), 1)
        ]),
        _: 1
      }, 8, ["color"])
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.label), 1),
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.value ?? '—'), 1)
      ])
    ])
  ], 8, _hoisted_1))
}
}

})